import {
	AirVent,
	BedDouble,
	BookOpen,
	Building2,
	Bus,
	Car,
	Circle,
	CircleParking,
	CloudRainWind,
	Coffee,
	Cookie,
	CookingPot,
	CupSoda,
	DoorOpen,
	Droplet,
	Fence,
	Flame,
	Footprints,
	Gamepad2,
	Hand,
	Lock,
	Mic,
	Microwave,
	Pipette,
	Projector,
	Refrigerator,
	Shirt,
	ShowerHead,
	SoapDispenserDroplet,
	Sofa,
	Sparkles,
	Speaker,
	Thermometer,
	Tv,
	UtensilsCrossed,
	WashingMachine,
	Wifi,
	Wind,
	Wine,
} from "lucide-react";

import { Bath } from "./custom-stroke/Bath";
import { Droplets } from "./custom-stroke/Droplets";
import { Grill } from "./custom-stroke/Grill";
import { Hairdryer } from "./custom-stroke/Hairdryer";
import { Razor } from "./custom-stroke/Razor";
import { TowelRack } from "./custom-stroke/TowelRack";
import { Waves } from "./custom-stroke/Waves";

import type { IconProps } from "./types";
import type { ComponentType } from "react";

/**
 * ServiceIcon: iconName → React コンポーネントの解決レイヤー。
 *
 * ゲスト側 app/frontend/guest/_shared/src/components/facility-info/icons/ServiceIcon.astro
 * + service-icon-registry.ts の代わりに、lucide-react + 手書きコンポーネントで解決する。
 *
 * 方針: 全アイコンを stroke（アウトライン）表示に統一する。
 * guest registry の Material Symbols fill 系（BathPublicLarge, Sauna 等 7 件）は、
 * ホストプレビューでの視覚的一貫性のため lucide の stroke 相当に再マップする
 * （塗りつぶしアイコンが混在して浮く問題を回避）。
 */
const ICON_COMPONENTS: Record<string, ComponentType<IconProps>> = {
	// lucide-react 標準 stroke
	AirVent,
	BedDouble,
	BookOpen,
	Building2,
	Bus,
	Car,
	CircleParking,
	CloudRainWind,
	Coffee,
	Cookie,
	CookingPot,
	CupSoda,
	DoorOpen,
	Droplet,
	Fence,
	Flame,
	Footprints,
	Gamepad2,
	Hand,
	Lock,
	Mic,
	Microwave,
	Pipette,
	Projector,
	Refrigerator,
	Shirt,
	ShowerHead,
	SoapDispenserDroplet,
	Sofa,
	Sparkles,
	Speaker,
	Thermometer,
	Tv,
	UtensilsCrossed,
	WashingMachine,
	Wifi,
	Wind,
	Wine,

	// registry 独自 stroke（lucide と同名だが path が違うもの、および lucide 非搭載）
	Bath,
	Droplets,
	Grill,
	Hairdryer,
	Razor,
	TowelRack,
	Waves,

	// Material Symbols fill 系を stroke 相当にリマップ（ホストプレビュー固有の処置）
	BathPublicLarge: Bath, // 大浴場 → 共通 Bath stroke
	BathOutdoor: Waves, // 露天風呂 → 波形 stroke
	BathPrivate: Bath, // 客室風呂 → 共通 Bath stroke
	Sauna: Flame, // サウナ → 炎 stroke
	Dentistry: Sparkles, // 歯ブラシ → セルフケア系 stroke（lucide に歯ブラシなし）
	SelfCare: Sparkles, // セルフケア → stroke
	Kettle: Coffee, // ポット → コーヒー器具 stroke（lucide に Kettle なし）
};

type Props = IconProps & {
	iconName: string;
};

export const ServiceIcon = ({ iconName, ...rest }: Props) => {
	const Component = ICON_COMPONENTS[iconName] ?? Circle;
	return <Component {...rest} />;
};
